import { Box, Skeleton } from "@mui/material";
import GraphMap from "../../../../../../../../../../components/charts/GraphMap";
import { MarkerLayer } from "../../../../../../../../../../components/charts/GraphMap/layers";
import { BaseNodeDTO } from "../../../../../../../../../../datasources/api-client/data-contracts";
import { ThemeColors } from "../../../../../../../../../../theme/themeValues";

type Props = {
	nodes: BaseNodeDTO[];
	loading?: boolean;
	onSelectNode: (node: BaseNodeDTO) => void;
};

export const NodeSearchMap = ({ nodes, loading, onSelectNode }: Props) => {
	const mapNodes = nodes.filter((node) => node.lat && node.lng);

	const center =
		mapNodes.length === 1 && mapNodes[0].lat != null && mapNodes[0].lng != null
			? ([mapNodes[0].lat, mapNodes[0].lng] as [number, number])
			: undefined;

	return (
		<Box height={400} borderRadius={2} sx={{ backgroundColor: ThemeColors.LightBackground }}>
			{loading ? (
				<Skeleton variant="rounded" height="100%" width="100%" />
			) : (
				<GraphMap tileProvider="heremaps" center={center} zoom={3} maxZoom={20} minZoom={1}>
					<MarkerLayer
						nodes={mapNodes}
						color={ThemeColors.LightPrimary}
						showDetailsOnClick
						onSelectNode={onSelectNode}
					/>
				</GraphMap>
			)}
		</Box>
	);
};
